import isDev from '@/utils/verifyDevelopmentEnv';

export const log = (...args) => {
  const reallyArgs = args.filter(arg => arg !== 'force');
  (reallyArgs.length !== args.length || isDev()) && console.log(...reallyArgs);
};

export const errorLog = err => log('force', 'error>>', err?.response || err);
